import React from 'react';
import { Form, Space, Button, Select, Popconfirm, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { cloneDeep } from 'lodash';
import DateRangePicker from '../DateRangePicker';

import { useGetHolidays } from 'hooks/product-price/base/getHolidays';

import moment from 'moment';
interface PropsType {
  enums?: any
}

const DEGAULT_FIELDS = [
  { },
  { },
  { },
  { }
];

const textStyle: React.CSSProperties = { display: 'inline-block', height: 32, lineHeight: '32px', padding: '0 12px' };

const HourlyRate:React.FC<PropsType> = (props) => {
  const { enums } = props;
  const { f_price_cancel_hours_list, f_price_cancel_percent_list } = enums || {};

  const { holidayEnum } = useGetHolidays();

  const form = Form.useFormInstance();
  const handleToChange = () => {
    
    const rule = cloneDeep(form.getFieldValue(['holiday', 'cancel_rules']));
    rule.forEach((item: any, index: number) => {
      if (item.to === 0) { // 为了解决新增一行to为0的情况
        item.to = '';
      }
      if (rule[index - 1]) {
        item.from = index === 1 ? rule[index - 1].from : rule[index - 1].to;
      }
    });
    rule[0].to = -1;
    rule[0].percent = 0;
    rule[rule.length - 2].to = 0;
    rule[rule.length - 1].from = rule[rule.length - 1].to = -1;
    form.setFieldValue(['holiday', 'cancel_rules'], rule);
  }

  const handleRangeSet = (item: any, subOpt: any) => {
    const rangeInfo = form.getFieldValue(['holiday', 'holiday_ranges']);
    if (!rangeInfo[(rangeInfo || []).length - 1]) {
      rangeInfo[(rangeInfo || []).length - 1] = {};
    }
    rangeInfo[(rangeInfo || []).length - 1].date_ranges = item.date_ranges;
    form.setFieldValue(['holiday', 'holiday_ranges'], rangeInfo);
  }

  const StartFormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <span style={{ marginRight: 10 }}>取车前</span>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          JSON.stringify(prevValues) !== JSON.stringify(curValues)
        }
      >
        {() => (
          <Form.Item
            name={[field.name, 'from']}
            rules={[{ required: true, message: '请选择距离' }]}
            style={{ display: 'inline-block' }}
          >
            <Select style={{ width: 130 }} onChange={handleToChange}>
              {(f_price_cancel_hours_list || []).map((item: any) => (
                <Select.Option key={item.key} value={item.key}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </Form.Item>
      <div style={textStyle}>（含）免费取消</div>
    </>
  );

  const FormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <Form.Item>
        <span style={{ marginRight: 10 }}>取车前</span>
        <Form.Item
          label=""
          name={[field.name, 'from']}
          rules={[{ required: true, message: '请选择距离' }]}
          style={{ display: 'inline-block' }}
        >
          <Select disabled style={{ width: 130 }}>
            {(f_price_cancel_hours_list || []).map((item: any) => (
              <Select.Option key={item.key} value={item.key}>
                {item.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div style={textStyle}>至</div>
        <Form.Item
          label=""
          name={[field.name, 'to']}
          rules={[{ required: true, message: '请选择费用' }]}
          style={{ display: 'inline-block' }}
        >
          <Select style={{ width: 130 }} onChange={handleToChange}>
            {(f_price_cancel_hours_list || []).map((item: any) => (
              <Select.Option key={item.key} value={item.key}>
                {item.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        （含）照订单总金额收取
        <Form.Item
          label=""
          name={[field.name, 'percent']}
          rules={[{ required: true, message: '请选择费用' }]}
          style={{ display: 'inline-block' }}
        >
          <Select style={{ width: 130 }}>
            {(f_price_cancel_percent_list || []).map((item: any) => (
              <Select.Option key={item.key} value={item.key}>
                {item.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {index > 0 && <Popconfirm
          title="确认删除吗?"
          onConfirm={() => {
            remove(field.name)
            handleToChange();
          }}
          okText="确认"
          cancelText="取消"
        >
          <Button danger style={{ marginLeft: 10 }}>删除</Button>
        </Popconfirm>}
      </Form.Item>
    </>
  );

  const EndSecondFormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <span style={{ marginRight: 10 }}>取车前</span>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) =>
          JSON.stringify(prevValues) !== JSON.stringify(curValues)
        }
      >
        {() => (
          <Form.Item
            name={[field.name, 'from']}
            rules={[{ required: true, message: '请选择距离' }]}
            style={{ display: 'inline-block' }}
          >
            <Select disabled style={{ width: 130 }}>
              {(f_price_cancel_hours_list || []).map((item: any) => (
                <Select.Option key={item.key} value={item.key}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </Form.Item>
      <div style={textStyle}>内 按照订单总金额收取</div>
      <Form.Item
        label=""
        name={[field.name, 'percent']}
        rules={[{ required: true, message: '请选择费用' }]}
        style={{ display: 'inline-block' }}
      >
        <Select style={{ width: 130 }}>
          {(f_price_cancel_percent_list || []).map((item: any) => (
            <Select.Option key={item.key} value={item.key}>
              {item.value}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );

  const EndFormItem = (fields: any, field: any, index: number, remove: any) => (
    <>
      <span style={{ marginRight: 10, lineHeight: '32px' }}>超过取车时间，按照订单总金额收取</span>
      <Form.Item
        label=""
        name={[field.name, 'percent']}
        rules={[{ required: true, message: '请选择费用' }]}
        style={{ display: 'inline-block' }}
      >
        <Select style={{ width: 130 }}>
          {(f_price_cancel_percent_list || []).map((item: any) => (
            <Select.Option key={item.key} value={item.key}>
              {item.value}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );

  return (
    <>
      <div style={{ marginBottom: 6, fontSize: '14px', fontWeight: 'bold' }}>
        节假日取消规则 <span style={{ marginLeft: 12, fontSize: '12px', fontWeight: 'normal' }}>支付完成15分钟内免费取消</span>
      </div>
      <div style={{ padding: '20px 12px', border: '1px solid rgba(0, 0, 0, 0.15)', borderRadius: 6 }}>
        <Form.Item label="节假日时段" labelCol={{ span: 3 }} style={{ marginBottom: 0 }}>
          <Form.List name={['holiday', 'holiday_ranges']} initialValue={[{}]}>
            {(subFields, subOpt) => (
              <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                <div>
                  <Button type="dashed" onClick={() => subOpt.add()}>
                    添加时段
                  </Button>
                  {(holidayEnum || []).map((item: any) => {
                    return (
                      <Button style={{ marginLeft: '12px' }} type="dashed" onClick={() => { subOpt.add(); handleRangeSet(item, subOpt)}}>
                        {item.name}
                      </Button>
                    )
                  })}
                </div>
                {subFields.map((subField) => (
                    <Space key={subField.key}>
                      <Form.Item noStyle name={[subField.name, 'date_ranges']} rules={[{ required: true, message: "" }]}>
                        <DateRangePicker
                          previousDisabled
                          disabledDate={(current: any, startDate: any) => {
                            return startDate ? current && current.isAfter(moment(startDate).add(10, 'days')) : false;
                          }}
                        />
                      </Form.Item>
                      <Popconfirm
                        title="请确认删除对应起租日设置?"
                        onConfirm={() => {
                            subOpt.remove(subField.name);
                        }}
                        okText="确认"
                        cancelText="取消"
                      >
                        <Button danger>删除</Button>
                      </Popconfirm>
                  </Space>
                ))}
              </div>
            )}
          </Form.List>
        </Form.Item>

        <Divider />

        <Form.Item label="取消收费规则" labelCol={{ span: 3 }}>
          <Form.List name={['holiday', 'cancel_rules']} initialValue={DEGAULT_FIELDS}>
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => {
                  return (
                    <div key={field.key}>
                      {index ===0 && StartFormItem(fields, field, index, remove)}
                      {index > 0 && index < fields.length - 2 && FormItem(fields, field, index, remove)}
                      {index === fields.length - 2 && EndSecondFormItem(fields, field, index, remove)}
                      {index === fields.length - 1 && EndFormItem(fields, field, index, remove)}
                    </div>
                  )
                })}
                <Form.Item>
                  <Button type="dashed" onClick={() => { add({}); handleToChange();}} block icon={<PlusOutlined />}>
                    添加
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form.Item>
      </div>
    </>
  )
}

export default HourlyRate;
